export function isReauthLandingVisible(options) {
    if (options.isLoggedIn)
        return false;
    return options.loginScreen !== "STANDARD_LOGIN" && !!options.reauthFirstName;
}
export function isDeviceHintOTPReauthVisible(state) {
    return (state.showOTPReauth &&
        state.showReauthLanding &&
        state.loginUIState === "login" &&
        !state.isLoadingLoginState &&
        state.loginStateLoaded &&
        !state.blockedByPostLoginFlow);
}
